import {
  homeDetailsColumnSx,
  homeDetailsPaperSx,
  homeDetailsWrapperSx
} from '../../../Common/components/Styles/InputStyles';

export const searchDetailsRootSx = {
  ...homeDetailsWrapperSx,
  height: 'calc(100vh - 130px)',
  minHeight: 0,
  overflow: 'hidden'
};

export const searchDetailsPaperSx = {
  ...homeDetailsPaperSx,
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const searchDetailsGridSx = {
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const searchDetailsGridItemSx = {
  display: 'flex',
  height: '100%',
  minHeight: 0,
  overflow: 'hidden'
};

export const searchDetailsColumnSx = {
  ...homeDetailsColumnSx,
  display: 'flex',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden'
};